import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@massilia/ui'
import { MailIcon, PhoneIcon } from 'lucide-react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'
import { AGENCY_EMAIL, AGENCY_PHONE } from '@/lib/constants/agency'

export type BookingContactModalVariant = 'annulation' | 'modification' | null

interface BookingContactModalProps {
  onClose: () => void
  variant: BookingContactModalVariant
}

const variantConfig = {
  annulation: {
    description:
      'Pour une annulation, veuillez nous joindre par téléphone ou par email avec votre numéro de dossier',
    title: 'Annulation',
  },
  modification: {
    description:
      'Pour une modification, veuillez nous joindre par téléphone ou par email avec votre numéro de dossier',
    title: 'Modification',
  },
} as const

export function BookingContactModal({ onClose, variant }: BookingContactModalProps) {
  if (!variant) return null

  const config = variantConfig[variant]

  return (
    <Dialog onOpenChange={(open) => !open && onClose()} open>
      <DialogContent className="gap-6 rounded-2xl bg-white p-8">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">{config.title}</DialogTitle>
        </DialogHeader>

        <p className="text-gray-light-700 text-sm">{config.description}</p>

        <div className="flex flex-col gap-4">
          <CopiableContactField icon={PhoneIcon} label="Téléphone" value={AGENCY_PHONE} />
          <CopiableContactField icon={MailIcon} label="Adresse email" value={AGENCY_EMAIL} />
        </div>

        <Button
          className="bg-brand-600 hover:bg-brand-800 w-full px-8 py-2 text-white"
          onClick={onClose}
        >
          D&apos;accord
        </Button>
      </DialogContent>
    </Dialog>
  )
}
